/**
 * promise 를 이용하여 future 를 구현
 */
class Future<R, E = unknown> {
  private readonly myPromise: Promise<R>;
  private resolver: (value: R) => void;
  private rejector: (reason?: E) => void;

  constructor() {
    this.myPromise = new Promise<R>((resolve, reject) => {
      this.resolver = resolve;
      this.rejector = reject;
    });
  }

  complete(data: R): void {
    this.resolver(data);
  }

  error(reason?: E): void {
    this.rejector(reason);
  }

  /**
   * 프로미스를 반환하므로 await xxx.get() 형태로 사용해야 함
   */
  get(): Promise<R> {
    return this.myPromise;
  }
}

export default Future;
